export const STRIPE_BASE_URL = 'https://dashboard.stripe.com/customers';
export const SALESFORCE_BASE_URL =
  'https://brainhi.lightning.force.com/lightning/r/Account/{salesforce_id}/view';

export enum Action {
  SET_ACCOUNT = 'SET_ACCOUNT',
  UPDATE_USER = 'UPDATE_USER',
  CREATE_NEW_BUSINESS_PHONE = 'CREATE_NEW_BUSINESS_PHONE',
  CREATE_NEW_USER = 'CREATE_NEW_USER',
  UPDATE_BUSINESS_PHONE = 'UPDATE_BUSINESS_PHONE',
  UPDATE_ACCOUNT_NAME = 'UPDATE_ACCOUNT_NAME',
  UPDATE_ACCOUNT_FEATURES = 'UPDATE_ACCOUNT_FEATURES',
  UPDATE_TWILIO_CONFIGURATION = 'UPDATE_TWILIO_CONFIGURATION',
  UPDATE_BILLING_SETTING = 'UPDATE_BILLING_SETTING',
}

export const TIMEZONE_DISPLAY_NAME: { [key: string]: string } = {
  'America/Puerto_Rico': 'PR',
  'America/New_York': 'EST',
  'America/Los_Angeles': 'PST',
  'America/Chicago': 'CST',
};

export const EMAIL_PATTERN =
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const USERNAME_PATTERN = /^[\w.@+\\-]+$/;
